import Paths from "../util/paths";
import AbstractEntity from "./abstractEntity";

/*
leagueSeason properties:
  - colors
  - id
  - league (id)
  - season
  - settingsDraft
  - settingsLeague
    - divisionSeasons
  - settingsLineup
  - settingsRoster
 */
class LeagueSeason extends AbstractEntity {
  /**
   *
   * @param {object} leagueSeasonObj
   * @param {UserInfo} userInfo
   */
  constructor(leagueSeasonObj, userInfo) {
    super(leagueSeasonObj, userInfo);

    if (this.obj && this.userInfo) {
      this.leagueObj = this.getLeagueObj();

      this.label = `${this.leagueObj.name} ${this.obj.season}`;
      this.pathDeps = {
        league: this.leagueObj,
        season: this.obj.season,
        leagueSeason: this.obj,
      };
      this.defaultPathName = "leagueSeasonHome";
    }
  }

  /**
   *
   * @returns {object[]}
   */
  getDivisionSeasonObjs() {
    let divisionSeasonsArray = this.obj.settingsLeague.divisionSeasons;

    let divisionSeasonObjs = [];
    if (divisionSeasonsArray && divisionSeasonsArray.length) {
      divisionSeasonObjs = divisionSeasonsArray.map((id) =>
        this.userInfo.getDivisionSeasonObj(id)
      );
    }

    return divisionSeasonObjs;
  }

  /**
   *
   * @returns {object}
   */
  getLeagueObj() {
    return this.userInfo.getLeagueObj(this.obj.league);
  }

  /**
   *
   * @returns {string}
   */
  getPathNoWeek() {
    let paths = new Paths(this.pathDeps);
    return paths.get("leagueSeasonHomeNoWeek");
  }
}

export default LeagueSeason;
